<template>
  <v-row dense justify="center">
    <v-col cols="12" class="title d-flex align-center">
      <v-icon color="secondary" left>mdi-forum</v-icon> Fóruns
    </v-col>
    <template v-if="forums">
      <v-col cols="12" md="4" v-for="item in forums" :key="item.id">
        <v-sheet outlined rounded class="fill-height">
          <v-list-item two-line :to="{ name: 'ambienteAluno.forum.topics', params: { forumId: item.group.forum.id } }">
            <v-list-item-avatar>
              <v-icon class="secondary--text">mdi-forum</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-black">
                {{ item.group.forum.title }}
              </v-list-item-title>
              <v-list-item-subtitle class="font-weight-bold">
                Curso {{ item.group.syllabus.course.name }}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="font-weight-regular">
                Turma {{ item.group.name }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-sheet>
      </v-col>
    </template>
    <template v-else>
      <v-col cols="12">
        <v-layout column class="pa-4">
          <v-icon size="124">mdi-emoticon-sad-outline</v-icon>
          <v-flex class="text-center">
            <span>Oops! Você ainda não está cadastrado em nenhum fórum.</span>
          </v-flex>
        </v-layout>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { Forum } from '@/services/resources.js'

export default {
  data () {
    return {
      forums: []
    }
  },
  mounted () {
    Forum.listAllForums()
      .then((response) => {
        this.forums = Object.values(response.body.forums)
      })
      .catch((error) => {
        console.log('responseError', error)
        this.$toasted.global.error({ message: error.statusText })
      })
  }
}
</script>
